<template>
  <Department
    :value.sync="dep"
    :options="{
      depType: 2,
    }"
    :person="false"
  />
</template>

<script>
import Department from "@/components/Department";
export default {
  name: "Depcomponent",
  components: {
    Department,
  },
  props: ["item"],
  data() {
    return {
      dep: "",
    };
  },
  beforeMount() {
    this.dep = this.item;
  },
  watch: {
    dep(val) {
      this.$emit("update:item", val);
    },
    item(val) {
      this.dep = val;
    },
  },
};
</script>

<style>
</style>